import { EmbedContainer } from './Container';
import { LiveboardEmbed } from '@thoughtspot/visual-embed-sdk/react';
import { NoObjectSelected } from './NoObjectSelected';
import { useEffect, useState } from 'react';
import { useVariable } from 'context/ThemeContext';
import { VIZ_EMBED_FEATURE_FLAGS } from '../../constants';

const VizEmbedBase = ({ embedRef, variables, embedSelections, setEmbedSelections }: any) => {
  const liveboardId = embedSelections?.pinboard;
  const vizId = embedSelections?.viz;
  const {
    state: { liveboardList },
  } = useVariable();
  const [idToRender, setIdToRender] = useState(null);
  const [showNoObjectSelected, setShowNoObjectSelected] = useState(false);
  useEffect(() => {
    const defaultLiveboardId = liveboardList?.length > 0 ? liveboardList[0]?.id : undefined;
    const defaultVizId = liveboardList?.length > 0 ? liveboardList[0]?.vizId : undefined;
    if (setEmbedSelections) {
      setEmbedSelections({
        pinboard: liveboardId || defaultLiveboardId,
        viz: vizId || defaultVizId,
      });
    }
  }, [liveboardList, setEmbedSelections, liveboardId, vizId]);

  const effectiveLiveboardId =
    liveboardId || (liveboardList?.length > 0 ? liveboardList[0]?.id : null);

  useEffect(() => {
    setIdToRender(effectiveLiveboardId);
  }, [effectiveLiveboardId]);

  useEffect(() => {
    if (!idToRender) {
      const timer = setTimeout(() => {
        setShowNoObjectSelected(true);
      }, 1000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [idToRender]);

  return idToRender ? (
    <LiveboardEmbed
      frameParams={{
        height: '100%',
      }}
      ref={embedRef}
      className="embed-content"
      disabledActionReason="Viz Embed"
      liveboardId={idToRender}
      vizId={vizId}
      showLiveboardDescription
      showLiveboardTitle
      {...VIZ_EMBED_FEATURE_FLAGS}
      customizations={{
        style: {
          customCSS: {
            variables: variables,
          },
        },
      }}
    />
  ) : showNoObjectSelected ? (
    <NoObjectSelected title="No Liveboard selected" description="Select a Liveboard to see it" />
  ) : null;
};

export const VizEmbedPage = (props) => {
  return <EmbedContainer EmbedComponent={VizEmbedBase} {...props} />;
};
